import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Button, Box } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { closePublishContainerDialog } from "actions/publish-container-dialog"
import PublishPost from "./steps/PublishPost"
import ShareWithPartner from "./steps/ShareWithPartner"
import DialogsContainerDialog from "../DialogsContainer"
import { publishPost, getPosts } from "actions/posts"
import { openSnackBar } from "actions/snack-bar"
import { uploadPostImage } from "actions/cloudinary"
import { openCropDialogDialog } from "actions/crop-dialog-dialog"
// import { updatePost } from "actions/posts"
import cloudinary from "cloudinary-core"
// import { isEmptyArray } from "formik"
import { isEmpty, uniq } from "lodash"
const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})
// import { facebookPost } from "actions/facebook"
import LoaderButton from "../../components/LoaderButton"
import moment from "moment"
import Email from "./steps/Email"
import { notifications } from "actions/posts"

function toDataUrl(url, callback) {
  var xhr = new XMLHttpRequest()
  xhr.onload = function() {
    var reader = new FileReader()
    reader.onloadend = function() {
      callback(reader.result)
    }
    reader.readAsDataURL(xhr.response)
  }
  xhr.open("GET", url)
  xhr.responseType = "blob"
  xhr.send()
}

const PublishContainerDialog = ({ classes }) => {
  const dispatch = useDispatch()
  let {
    open,
    data,
    hashtags,
    emailsWithTags,
    tags,
    orgName,
    logo,
    whiteLabeled
  } = useSelector(state => ({
    open: state.publishContainerDialog.open,
    data: state.publishContainerDialog.data,
    hashtags: state.organization.currentOrg.hashtags,
    tags: state.organization.currentOrg.tags,
    emailsWithTags: state.organization.currentOrg.emailsWithTags,
    orgName: state.organization.currentOrg.name,
    whiteLabeled: state.organization.currentOrg.white_labeled,
    logo: state.organization.currentOrg.logo
  }))
  const [working, setWorking] = useState(false)
  //post text
  const [postBody, setPostBody] = useState()
  const [postLocation, setPostLocation] = useState()
  const [postAuthor, setPostAuthor] = useState()
  const [postImage, setPostImage] = useState()
  const [postNetworks, setPostNetworks] = useState([])
  const [selectedLinkedinOrgs, setSelectedLinkedinOrgs] = useState([])
  const [selectedFacebookOrgs, setSelectedFacebookOrgs] = useState([])

  const [currentStep, setCurrentStep] = useState(0)
  //organizations that we are connected with
  const [sharePartners, setSharePartners] = useState([])
  const [crop, setCrop] = useState(null)
  //swicht that allows us select organizations that we are connected with
  const [useShare, setUseShare] = useState(false)
  //swicht that allows us select tags or emails to send
  const [useEmail, setUseEmail] = useState(false)
  const [emailSubject, setEmailSubject] = useState("")
  const [emailMessage, setEmailMessage] = useState("")
  //tags and emails array to send notification
  const [emailsTagsArrayToSend, setEmailsTagsArrayToSend] = useState([])
  //state for the buttons (select/selected)
  const [changeButton, setChangeButton] = useState({})
  //to know if we upload image or video
  const [uploadType, setUploadType] = useState(null)
  const [source, setSource] = useState(null)
  //image to show in the dialog for the video
  const [videoImage, setVideoImage] = useState(null)
  const [downloadSource, setDownloadSource] = useState(null)
  // Handle errors to disable publish button
  const [hasErrors, setHasErrors] = useState({
    Twitter: { error: false, message: "" }
  })

  const [selectedDate, setSelectedDate] = React.useState(
    moment
      .utc(new Date())
      .add(1, "days")
      .format()
  )
  // Set initial form data once modal is opened
  useEffect(() => {
    setEmailSubject(`${orgName} has shared an update with you!`)
    if (hashtags) {
      setPostBody(`${data.body}\n\n${hashtags.replace(/,/g, " ")}`)
    } else {
      setPostBody(data.body)
    }
    setPostAuthor(data.first_name + " " + data.last_name)

    setPostLocation(data.location)

    setPostLocation(data.location)

    if (data.image) {
      setPostImage(JSON.parse(data.image))
      const fileObj = JSON.parse(data.image)
      setUploadType(fileObj.resource_type)
      // if (fileObj.resource_type === "image") {
      // console.log(data.image)
      // dispatch(openCropDialogDialog({ image: JSON.parse(data.image) }))
      //   .then(res => {
      //     setCrop(res)
      //     this.makeCrop()
      //   })
      //   .catch(err => {
      //     setPostImage(JSON.parse(data.image))
      //   })
      // }
    }
  }, [data])

  const handleEmails = () => {
    /* eslint-disable */

    return new Promise((resolve, reject) => {
      if (useEmail) {
        let newEmailListOfEmails = [
          ...emailsTagsArrayToSend.map(x =>
            x.type === "email" ? x.name : null
          )
        ].filter(x => x !== null)
        let newEmailsListOfTags = emailsTagsArrayToSend
          .map(x =>
            x.type === "tag"
              ? emailsWithTags
                  .filter(y => y.tags)
                  .map(y => (y.tags.includes(x.id) ? y.email : null))
                  .filter(x => x !== null)
              : null
          )
          .filter(x => x !== null)
        let newEmailList = []
        if (newEmailsListOfTags.length === 0) {
          newEmailList = uniq([...newEmailListOfEmails, ...newEmailsListOfTags])
        } else {
          newEmailList = uniq([
            ...newEmailListOfEmails,
            ...newEmailsListOfTags[0]
          ])
        }
        /* eslint-enable */

        dispatch(
          notifications({
            emails: newEmailList,
            subject: emailSubject,
            orgName: orgName,
            author: postAuthor,
            postBody: postBody,
            content: emailMessage,
            postImage: uploadType === "image" ? source : videoImage,
            download: downloadSource,
            logo:
              whiteLabeled === 0
                ? "https://app.firstlinesocial.com/static/media/firstline_social_icon_logo.cedebfc8.png"
                : JSON.parse(logo).url,
            //send the play bottom or a transparent image to create the image
            type:
              uploadType === "video"
                ? "https://i.ibb.co/XtQNnhs/Play-icon-white.png"
                : "https://i.ibb.co/wzg985k/Transparent-box.png"
          })
        )
          .then(res => {
            resolve(res)
            dispatch(openSnackBar({ message: "Emails Sent" }))
          })
          .catch(err => reject(err))
      } else {
        resolve(true)
      }
    })
  }

  const makeCrop = () => {
    const deferred = new Promise((resolve, reject) => {
      try {
        toDataUrl(
          cl.url(
            postImage.public_id,
            crop
              ? /* eslint-disable */
                {
                  width: crop.width,
                  height: crop.height,
                  x: crop.x,
                  y: crop.y,
                  crop: "crop"
                }
              : undefined
            /* eslint-enable */
          ),
          imageData => {
            dispatch(uploadPostImage(imageData))
              .then(imageRes => {
                setPostImage(JSON.stringify(imageRes))
                resolve(imageRes)
              })
              .catch(err => {
                console.error(err)
                dispatch(openSnackBar({ message: "Post failed." }))
                reject(err)
              })
          }
        )
      } catch (err) {
        console.error(err)
        dispatch(openSnackBar({ message: "Post failed." }))
        reject(err)
      }
    })
    return deferred
  }

  const doPublishPost = image => {
    const submitData = {
      body: postBody,
      location: postLocation,
      networks: postNetworks,
      sharePartners: sharePartners,
      posterId: data.user_id,
      scheduledDate: selectedDate,
      linkedinOrgs: selectedLinkedinOrgs,
      facebookOrgs: selectedFacebookOrgs
    }

    if (postNetworks.includes("Hootsuite") && selectedDate === "Invalid date") {
      setWorking(false)
      dispatch(openSnackBar({ message: "Please select a valid date." }))
      return
    }
    if (image) {
      if (typeof image === "string") {
        submitData.image = image
      } else {
        submitData.image = JSON.stringify(image)
      }
    } else if (postImage.resource_type === "image") {
      submitData.image = JSON.stringify(postImage)
    } else {
      submitData.video = JSON.stringify(postImage)
    }

    dispatch(publishPost(data.id, submitData))
      .then(res => {
        return JSON.parse(res)
      })
      .then(res => {
        dispatch(openSnackBar({ message: res.message }))
        handleEmails()
      })
      .catch(error => {
        dispatch(openSnackBar({ message: "Post failed." }))
        dispatch(closePublishContainerDialog())
        setWorking(false)
      })
      .finally(() => {
        dispatch(closePublishContainerDialog())
        dispatch(getPosts())
        setCrop(null)
        setPostNetworks([])
        setUseShare(false)
        setUseEmail(false)
        setEmailsTagsArrayToSend([])
        setWorking(false)
        setCurrentStep(0)
        setSelectedFacebookOrgs([])
        setSelectedLinkedinOrgs([])
        setEmailMessage("")
        setUseEmail(false)
        setUseShare(false)
      })
  }

  const handleBack = val => {
    if (currentStep === 0 || (val && val === "close")) {
      dispatch(closePublishContainerDialog())
      dispatch(getPosts())
      setCrop(null)
      setPostNetworks([])
      setUseShare(false)
      setUseEmail(false)
      setEmailsTagsArrayToSend([])
      setCurrentStep(0)
      setSelectedFacebookOrgs([])
      setSelectedLinkedinOrgs([])
      setEmailMessage("")
      setUseEmail(false)
      setUseShare(false)
    } else {
      setCurrentStep(currentStep - 1)
    }
  }
  const steps = [
    <PublishPost
      // setFormData={setFormData}
      data={data}
      setPostBody={setPostBody}
      setPostImage={setPostImage}
      setPostLocation={setPostLocation}
      setPostNetworks={setPostNetworks}
      setSelectedDate={setSelectedDate}
      setSelectedLinkedinOrgs={setSelectedLinkedinOrgs}
      selectedLinkedinOrgs={selectedLinkedinOrgs}
      setSelectedFacebookOrgs={setSelectedFacebookOrgs}
      selectedFacebookOrgs={selectedFacebookOrgs}
      postBody={postBody}
      postImage={postImage}
      postLocation={postLocation}
      postNetworks={postNetworks}
      selectedDate={selectedDate}
      crop={crop}
      onCropChange={setCrop}
      useShare={useShare}
      setUseShare={setUseShare}
      useEmail={useEmail}
      setUseEmail={setUseEmail}
      uploadType={uploadType}
      source={source}
      setSource={setSource}
      setUploadType={setUploadType}
      setDownloadSource={setDownloadSource}
      setVideoImage={setVideoImage}
      setHasErrors={setHasErrors}
      hasErrors={hasErrors}
      working={working}
    />,
    useEmail ? (
      <Email
        postBody={postBody}
        postImage={postImage}
        emailMessage={emailMessage}
        setEmailMessage={setEmailMessage}
        emailsTagsArrayToSend={emailsTagsArrayToSend}
        setEmailsTagsArrayToSend={setEmailsTagsArrayToSend}
        emailsWithTags={emailsWithTags}
        tags={tags}
        emailSubject={emailSubject}
        setEmailSubject={setEmailSubject}
        postAuthor={postAuthor}
        uploadType={uploadType}
        source={source}
        videoImage={videoImage}
      />
    ) : null,
    useShare ? (
      <ShareWithPartner
        sharePartners={sharePartners}
        setSharePartners={setSharePartners}
        changeButton={changeButton}
        setChangeButton={setChangeButton}
      />
    ) : null
  ].filter(Boolean)

  const handlePublish = () => {
    if (!isEmpty(crop)) {
      makeCrop().then(imageRes => {
        doPublishPost(imageRes)
      })
    } else {
      doPublishPost()
    }
  }
  const handleNext = () => {
    if (currentStep === steps.length - 1) {
      setWorking(true)
      handlePublish()
      // handleEmails()
      //   .then(handlePublish)
      //   .catch(err => {
      //     console.log(err)
      // })
    } else {
      setCurrentStep(currentStep + 1)
    }
  }

  const dialogTitle = () => {
    let title = ""
    if (currentStep === 0) {
      title = "Publish Post"
    } else if (currentStep === 1 && useEmail && useShare) {
      title = "Email"
    } else if (currentStep === 2 && useEmail && useShare) {
      title = "Share"
    } else if (currentStep === 1 && !useEmail && useShare) {
      title = "Share"
    } else if (currentStep === 1 && useEmail && !useShare) {
      title = "Email"
    }
    return title
  }

  return (
    <DialogsContainerDialog
      open={open}
      handleClose={() => handleBack("close")}
      title={dialogTitle()}
      content={steps[currentStep]}
      buttons={
        <Box className={classes.buttonsContainer} display="flex">
          <Button
            className={classes.cancelButton}
            onClick={handleBack}
            disabled={working}
            variant="text"
          >
            {currentStep === 0 ? "cancel" : "back"}
          </Button>

          <LoaderButton
            classes={{ button: classes.publishButton }}
            onClick={handleNext}
            working={working}
            disabled={
              // Checks if there are any errors preventing post from publishing
              // Checks if a network has been selected or if email/share has been selected
              Object.keys(hasErrors).some(
                key =>
                  hasErrors[key].error === true && postNetworks.includes(key)
              ) ||
              (postNetworks.length === 0 &&
                currentStep === steps.length - 1 &&
                steps.length === 1) ||
              working
            }
          >
            {currentStep === steps.length - 1 ? "publish" : "next"}
          </LoaderButton>
        </Box>
      }
    />
  )
}

export default withStyles(styles)(PublishContainerDialog)



// WEBPACK FOOTER //
// ./src/dialogs/PublishContainer/index.jsx